'use client'

import cn from 'classnames'
import { useTranslations } from 'next-intl'

import { useBookingState } from '@booking/state/booking.context'
import shared from '@booking/index.module.scss'
import SummaryBox from '@booking/components/SummaryBox'
import AssociateBox from '@booking/components/AssociateBox'

import styles from './index.module.scss'
import FindUsSection from './components/FindUsSection'

type AssociateTicketsProps = {
  allowAssociation?: boolean
}

export default function AssociateTickets({ allowAssociation = true }: AssociateTicketsProps) {
  const t = useTranslations('booking')
  const { cart } = useBookingState()

  if (!cart) {
    return <>{t('ticket.payment.pleaseWait')}</>
  }

  return (
    <div className={cn(shared.box, styles.wrapper)}>
      <div className={shared.inner}>
        <div className={shared.leftColumn}>
          {allowAssociation ? <AssociateBox /> : null}
          <FindUsSection />
        </div>

        <div className={shared.rightColumn}>
          <SummaryBox />
        </div>
      </div>
    </div>
  )
}
